import DocumentsManagerSupabase from "./DocumentsManagerSupabase";
import CalendarViewSupabase from "./CalendarViewSupabase";
import DashboardStats from "./DashboardStats";
import IncidentsManager from "./IncidentsManager";
import EFVPManager from "./EFVPManager";
import ConsentementsManager from "./ConsentementsManager";
// ObligationsManager retiré - table non utilisée
import { useAuth } from "../context/AuthContextSupabase";
import React, { useState, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import {
  AlertCircle,
  CheckCircle,
  Shield,
  Users,
  FileText,
  Bell,
  TrendingUp,
  Lock,
  Plus,
  ChevronDown,
  User,
  Settings,
  LogOut,
  Calendar,
  Clock,
  Database,
  Menu,
  X,
  AlertTriangle,
  Sparkles,
  ArrowRight,
  Rocket,
  BookOpen,
  Zap,
  Gift,
  Mail,
  Building2,
  CreditCard,
  Globe,
  Moon,
  Sun,
  Save,
  Camera,
  Check,
} from "lucide-react";
import Toast from "./Toast";
import ThemeToggle from "./ThemeToggle";
import UsersManagement from "./UsersManagement";
import EnhancedDashboard from "./EnhancedDashboard";
import ReportsGenerator from "./ReportsGenerator";
import AuditTimeline from "./AuditTimeline";
import InventaireManager from "./InventaireManager";

// ============================================
// MODAL DE BIENVENUE
// ============================================
const WelcomeModal = ({ user, onClose }) => {
  const [currentStep, setCurrentStep] = useState(0);

  const steps = [
    {
      icon: Gift,
      title: "Bienvenue sur CoryntiQ! 🎉",
      description:
        "Félicitations! Votre essai gratuit de 14 jours est maintenant actif. Vous avez accès à toutes les fonctionnalités pour gérer votre conformité à la Loi 25.",
      color: "sky",
    },
    {
      icon: Rocket,
      title: "Par où commencer?",
      description:
        "Nous vous recommandons de commencer par l'inventaire de vos renseignements personnels. C'est la base de votre conformité.",
      color: "indigo",
    },
    {
      icon: BookOpen,
      title: "Besoin d'aide?",
      description:
        "Notre équipe est là pour vous accompagner. N'hésitez pas à nous contacter à support@coryntiq.ca pour toute question.",
      color: "green",
    },
  ];

  const currentStepData = steps[currentStep];
  const StepIcon = currentStepData.icon;

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      onClose();
    }
  };

  const colorClasses = {
    sky: {
      bg: "bg-sky-500/20",
      icon: "text-sky-400",
      button: "bg-sky-500 hover:bg-sky-600",
      dot: "bg-sky-500",
    },
    indigo: {
      bg: "bg-indigo-500/20",
      icon: "text-indigo-400",
      button: "bg-indigo-500 hover:bg-indigo-600",
      dot: "bg-indigo-500",
    },
    green: {
      bg: "bg-green-500/20",
      icon: "text-green-400",
      button: "bg-green-500 hover:bg-green-600",
      dot: "bg-green-500",
    },
  };

  const colors = colorClasses[currentStepData.color];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative bg-gradient-to-br from-slate-800 to-slate-900 border border-slate-700 rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-sky-500 via-indigo-500 to-green-500" />
        <div className="absolute top-20 -right-20 w-64 h-64 bg-sky-500/10 rounded-full blur-3xl" />
        <div className="absolute bottom-20 -left-20 w-64 h-64 bg-indigo-500/10 rounded-full blur-3xl" />

        <div className="relative p-8">
          <div
            className={`w-20 h-20 ${colors.bg} rounded-2xl flex items-center justify-center mx-auto mb-6`}
          >
            <StepIcon className={`w-10 h-10 ${colors.icon}`} />
          </div>

          <h2 className="text-2xl font-bold text-white text-center mb-4">
            {currentStepData.title}
          </h2>
          <p className="text-slate-300 text-center leading-relaxed mb-8">
            {currentStepData.description}
          </p>

          <div className="flex justify-center gap-2 mb-8">
            {steps.map((_, index) => (
              <div
                key={index}
                className={`w-2 h-2 rounded-full transition-all ${
                  index === currentStep
                    ? `${colors.dot} w-6`
                    : index < currentStep
                    ? "bg-slate-500"
                    : "bg-slate-700"
                }`}
              />
            ))}
          </div>

          <div className="flex gap-4">
            {currentStep > 0 && (
              <button
                onClick={() => setCurrentStep(currentStep - 1)}
                className="flex-1 py-3 px-6 border border-slate-600 text-slate-300 rounded-xl hover:bg-slate-700 transition-colors"
              >
                Précédent
              </button>
            )}
            <button
              onClick={handleNext}
              className={`flex-1 py-3 px-6 ${colors.button} text-white rounded-xl font-semibold transition-colors flex items-center justify-center gap-2`}
            >
              {currentStep === steps.length - 1 ? (
                <>
                  Commencer
                  <Sparkles className="w-5 h-5" />
                </>
              ) : (
                <>
                  Suivant
                  <ArrowRight className="w-5 h-5" />
                </>
              )}
            </button>
          </div>

          <button
            onClick={onClose}
            className="w-full mt-4 text-sm text-slate-500 hover:text-slate-300 transition-colors"
          >
            Passer l'introduction
          </button>
        </div>

        <div className="bg-gradient-to-r from-green-500/20 to-emerald-500/20 border-t border-green-500/30 px-8 py-4">
          <div className="flex items-center justify-center gap-3">
            <div className="flex items-center gap-2 text-green-400">
              <Clock className="w-5 h-5" />
              <span className="font-semibold">14 jours d'essai gratuit</span>
            </div>
            <span className="text-slate-500">•</span>
            <span className="text-slate-400">Aucune carte débitée</span>
          </div>
        </div>
      </div>
    </div>
  );
};

// ============================================
// DROPDOWN NOTIFICATIONS
// ============================================
const NotificationsDropdown = ({ isOpen, onClose, entreprise }) => {
  const dropdownRef = useRef(null);

  const [notifications, setNotifications] = useState([
    {
      id: 1,
      type: "info",
      title: "Bienvenue sur CoryntiQ!",
      message: "Votre essai gratuit de 14 jours est actif.",
      time: "À l'instant",
      read: false,
      icon: Gift,
    },
    {
      id: 2,
      type: "warning",
      title: "Inventaire incomplet",
      message: "Complétez votre inventaire des données personnelles.",
      time: "Il y a 1 heure",
      read: false,
      icon: Database,
    },
    {
      id: 3,
      type: "success",
      title: "Compte créé avec succès",
      message: "Votre organisation a été configurée.",
      time: "Aujourd'hui",
      read: true,
      icon: CheckCircle,
    },
  ]);

  const markAsRead = (id) => {
    setNotifications(
      notifications.map((n) => (n.id === id ? { ...n, read: true } : n))
    );
  };

  const markAllAsRead = () => {
    setNotifications(notifications.map((n) => ({ ...n, read: true })));
  };

  const unreadCount = notifications.filter((n) => !n.read).length;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const typeColors = {
    info: "bg-sky-100 text-sky-600 dark:bg-sky-900/30 dark:text-sky-400",
    warning:
      "bg-amber-100 text-amber-600 dark:bg-amber-900/30 dark:text-amber-400",
    success:
      "bg-green-100 text-green-600 dark:bg-green-900/30 dark:text-green-400",
    error: "bg-red-100 text-red-600 dark:bg-red-900/30 dark:text-red-400",
  };

  return (
    <div
      ref={dropdownRef}
      className="absolute right-0 mt-2 w-80 bg-white dark:bg-gray-800 rounded-xl shadow-2xl border border-gray-200 dark:border-gray-700 z-50 overflow-hidden"
    >
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700/50">
        <h3 className="font-semibold text-gray-900 dark:text-white">
          Notifications
        </h3>
        {unreadCount > 0 && (
          <button
            onClick={markAllAsRead}
            className="text-xs text-sky-600 dark:text-sky-400 hover:underline"
          >
            Tout marquer comme lu
          </button>
        )}
      </div>

      <div className="max-h-80 overflow-y-auto">
        {notifications.length === 0 ? (
          <div className="p-6 text-center text-gray-500 dark:text-gray-400">
            <Bell size={32} className="mx-auto mb-2 opacity-50" />
            <p>Aucune notification</p>
          </div>
        ) : (
          notifications.map((notif) => {
            const NotifIcon = notif.icon;
            return (
              <div
                key={notif.id}
                onClick={() => markAsRead(notif.id)}
                className={`flex items-start gap-3 p-4 border-b border-gray-100 dark:border-gray-700 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors ${
                  !notif.read ? "bg-sky-50/50 dark:bg-sky-900/10" : ""
                }`}
              >
                <div className={`p-2 rounded-lg ${typeColors[notif.type]}`}>
                  <NotifIcon size={16} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between">
                    <p
                      className={`text-sm font-medium ${
                        !notif.read
                          ? "text-gray-900 dark:text-white"
                          : "text-gray-600 dark:text-gray-300"
                      }`}
                    >
                      {notif.title}
                    </p>
                    {!notif.read && (
                      <span className="w-2 h-2 bg-sky-500 rounded-full flex-shrink-0"></span>
                    )}
                  </div>
                  <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 truncate">
                    {notif.message}
                  </p>
                  <p className="text-xs text-gray-400 dark:text-gray-500 mt-1">
                    {notif.time}
                  </p>
                </div>
              </div>
            );
          })
        )}
      </div>

      <div className="px-4 py-3 bg-gray-50 dark:bg-gray-700/50 border-t border-gray-200 dark:border-gray-700">
        <button className="w-full text-sm text-sky-600 dark:text-sky-400 hover:underline font-medium">
          Voir toutes les notifications
        </button>
      </div>
    </div>
  );
};

// ============================================
// MODAL PROFIL
// ============================================
const ProfileModal = ({
  isOpen,
  onClose,
  user,
  profil,
  entreprise,
  showToast,
}) => {
  const [formData, setFormData] = useState({
    prenom: profil?.prenom || "",
    nom: profil?.nom || "",
    email: user?.email || "",
    telephone: "",
  });
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (profil) {
      setFormData({
        prenom: profil.prenom || "",
        nom: profil.nom || "",
        email: user?.email || "",
        telephone: profil.telephone || "",
      });
    }
  }, [profil, user]);

  const handleSave = async () => {
    setIsSaving(true);
    setTimeout(() => {
      setIsSaving(false);
      showToast("Profil mis à jour avec succès!", "success");
      onClose();
    }, 1000);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700">
          <h2 className="text-xl font-bold text-gray-900 dark:text-white">
            Mon profil
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg"
          >
            <X size={20} className="text-gray-500" />
          </button>
        </div>

        <div className="flex flex-col items-center py-6 bg-gradient-to-b from-slate-100 to-white dark:from-gray-700 dark:to-gray-800">
          <div className="relative">
            <div className="w-24 h-24 rounded-full bg-gradient-to-br from-sky-400 to-indigo-500 flex items-center justify-center text-white text-3xl font-bold">
              {formData.prenom?.charAt(0) ||
                user?.email?.charAt(0)?.toUpperCase() ||
                "U"}
            </div>
            <button className="absolute bottom-0 right-0 p-2 bg-white dark:bg-gray-700 rounded-full shadow-lg border border-gray-200 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600">
              <Camera size={16} className="text-gray-600 dark:text-gray-300" />
            </button>
          </div>
          <p className="mt-3 font-semibold text-gray-900 dark:text-white">
            {formData.prenom} {formData.nom}
          </p>
          <p className="text-sm text-gray-500 dark:text-gray-400">
            {entreprise?.nom || "Organisation"}
          </p>
        </div>

        <div className="p-6 space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Prénom
              </label>
              <input
                type="text"
                value={formData.prenom}
                onChange={(e) =>
                  setFormData({ ...formData, prenom: e.target.value })
                }
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg dark:bg-gray-700 dark:text-white"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Nom
              </label>
              <input
                type="text"
                value={formData.nom}
                onChange={(e) =>
                  setFormData({ ...formData, nom: e.target.value })
                }
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg dark:bg-gray-700 dark:text-white"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Courriel
            </label>
            <input
              type="email"
              value={formData.email}
              disabled
              className="w-full px-3 py-2 border border-gray-200 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700/50 text-gray-500 dark:text-gray-400 cursor-not-allowed"
            />
            <p className="text-xs text-gray-400 mt-1">
              Le courriel ne peut pas être modifié
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Téléphone
            </label>
            <input
              type="tel"
              value={formData.telephone}
              onChange={(e) =>
                setFormData({ ...formData, telephone: e.target.value })
              }
              placeholder="(514) 555-1234"
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg dark:bg-gray-700 dark:text-white"
            />
          </div>
        </div>

        <div className="flex gap-3 px-6 py-4 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700/50">
          <button
            onClick={onClose}
            className="flex-1 py-2 px-4 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-600 font-medium"
          >
            Annuler
          </button>
          <button
            onClick={handleSave}
            disabled={isSaving}
            className="flex-1 py-2 px-4 bg-sky-600 text-white rounded-lg hover:bg-sky-700 font-medium flex items-center justify-center gap-2 disabled:opacity-50"
          >
            {isSaving ? (
              <>
                <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                Enregistrement...
              </>
            ) : (
              <>
                <Save size={18} />
                Enregistrer
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

// ============================================
// MODAL PARAMÈTRES
// ============================================
const SettingsModal = ({ isOpen, onClose, entreprise, showToast }) => {
  const [activeSection, setActiveSection] = useState("general");
  const [settings, setSettings] = useState({
    langue: "fr",
    fuseau: "America/Toronto",
    emailNotifs: true,
    rappelsEcheances: true,
    alertesIncidents: true,
    resumeHebdo: false,
    twoFactor: false,
    sessionTimeout: "30",
  });

  const handleSave = () => {
    showToast("Paramètres enregistrés!", "success");
    onClose();
  };

  if (!isOpen) return null;

  const sections = [
    { id: "general", label: "Général", icon: Settings },
    { id: "notifications", label: "Notifications", icon: Bell },
    { id: "security", label: "Sécurité", icon: Shield },
    { id: "billing", label: "Abonnement", icon: CreditCard },
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-hidden">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700">
          <h2 className="text-xl font-bold text-gray-900 dark:text-white">
            Paramètres
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg"
          >
            <X size={20} className="text-gray-500" />
          </button>
        </div>

        <div className="flex h-[500px]">
          <div className="w-48 border-r border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700/30 p-3">
            {sections.map((section) => {
              const Icon = section.icon;
              return (
                <button
                  key={section.id}
                  onClick={() => setActiveSection(section.id)}
                  className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors mb-1 ${
                    activeSection === section.id
                      ? "bg-sky-100 dark:bg-sky-900/30 text-sky-700 dark:text-sky-400"
                      : "text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
                  }`}
                >
                  <Icon size={18} />
                  {section.label}
                </button>
              );
            })}
          </div>

          <div className="flex-1 p-6 overflow-y-auto">
            {activeSection === "general" && (
              <div className="space-y-6">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                  Paramètres généraux
                </h3>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Langue
                  </label>
                  <select
                    value={settings.langue}
                    onChange={(e) =>
                      setSettings({ ...settings, langue: e.target.value })
                    }
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg dark:bg-gray-700 dark:text-white"
                  >
                    <option value="fr">Français</option>
                    <option value="en">English</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Fuseau horaire
                  </label>
                  <select
                    value={settings.fuseau}
                    onChange={(e) =>
                      setSettings({ ...settings, fuseau: e.target.value })
                    }
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg dark:bg-gray-700 dark:text-white"
                  >
                    <option value="America/Toronto">
                      Heure de l'Est (Toronto/Montréal)
                    </option>
                    <option value="America/Vancouver">
                      Heure du Pacifique (Vancouver)
                    </option>
                  </select>
                </div>
              </div>
            )}

            {activeSection === "notifications" && (
              <div className="space-y-6">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                  Notifications
                </h3>
                <div className="space-y-4">
                  {[
                    {
                      key: "emailNotifs",
                      label: "Notifications par courriel",
                      desc: "Recevoir les notifications importantes par courriel",
                    },
                    {
                      key: "rappelsEcheances",
                      label: "Rappels d'échéances",
                      desc: "Être notifié des échéances à venir",
                    },
                    {
                      key: "alertesIncidents",
                      label: "Alertes incidents",
                      desc: "Recevoir une alerte immédiate lors d'un nouvel incident",
                    },
                    {
                      key: "resumeHebdo",
                      label: "Résumé hebdomadaire",
                      desc: "Recevoir un résumé chaque semaine",
                    },
                  ].map((item) => (
                    <div
                      key={item.key}
                      className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-700/30 rounded-lg"
                    >
                      <div>
                        <p className="font-medium text-gray-900 dark:text-white">
                          {item.label}
                        </p>
                        <p className="text-sm text-gray-500 dark:text-gray-400">
                          {item.desc}
                        </p>
                      </div>
                      <button
                        onClick={() =>
                          setSettings({
                            ...settings,
                            [item.key]: !settings[item.key],
                          })
                        }
                        className={`w-12 h-6 rounded-full transition-colors ${
                          settings[item.key]
                            ? "bg-sky-500"
                            : "bg-gray-300 dark:bg-gray-600"
                        }`}
                      >
                        <div
                          className={`w-5 h-5 bg-white rounded-full shadow transition-transform ${
                            settings[item.key]
                              ? "translate-x-6"
                              : "translate-x-0.5"
                          }`}
                        />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {activeSection === "security" && (
              <div className="space-y-6">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                  Sécurité
                </h3>
                <div className="p-4 bg-gray-50 dark:bg-gray-700/30 rounded-lg">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="font-medium text-gray-900 dark:text-white">
                        Authentification à deux facteurs
                      </p>
                      <p className="text-sm text-gray-500 dark:text-gray-400">
                        Ajouter une couche de sécurité supplémentaire
                      </p>
                    </div>
                    <button className="px-4 py-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-600 text-sm font-medium">
                      Configurer
                    </button>
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Expiration de session (minutes)
                  </label>
                  <select
                    value={settings.sessionTimeout}
                    onChange={(e) =>
                      setSettings({
                        ...settings,
                        sessionTimeout: e.target.value,
                      })
                    }
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg dark:bg-gray-700 dark:text-white"
                  >
                    <option value="15">15 minutes</option>
                    <option value="30">30 minutes</option>
                    <option value="60">1 heure</option>
                    <option value="120">2 heures</option>
                  </select>
                </div>
                <button className="text-red-600 dark:text-red-400 text-sm font-medium hover:underline">
                  Changer mon mot de passe
                </button>
              </div>
            )}

            {activeSection === "billing" && (
              <div className="space-y-6">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                  Abonnement
                </h3>
                <div className="p-4 bg-gradient-to-r from-sky-50 to-indigo-50 dark:from-sky-900/20 dark:to-indigo-900/20 rounded-lg border border-sky-200 dark:border-sky-800">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm text-sky-600 dark:text-sky-400 font-medium">
                        Plan actuel
                      </p>
                      <p className="text-2xl font-bold text-gray-900 dark:text-white">
                        {entreprise?.plan_actif === "essentiel"
                          ? "Essentiel"
                          : entreprise?.plan_actif === "professionnel"
                          ? "Professionnel"
                          : "Essai gratuit"}
                      </p>
                    </div>
                    {entreprise?.en_essai && (
                      <span className="px-3 py-1 bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400 rounded-full text-sm font-medium">
                        Essai actif
                      </span>
                    )}
                  </div>
                  {entreprise?.date_fin_essai && (
                    <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
                      Fin de l'essai:{" "}
                      {new Date(entreprise.date_fin_essai).toLocaleDateString(
                        "fr-CA"
                      )}
                    </p>
                  )}
                </div>
                <div className="space-y-3">
                  <button className="w-full py-3 px-4 bg-sky-600 text-white rounded-lg hover:bg-sky-700 font-medium">
                    Changer de plan
                  </button>
                  <button className="w-full py-3 px-4 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 font-medium">
                    Gérer le mode de paiement
                  </button>
                  <button className="w-full py-3 px-4 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 font-medium">
                    Voir les factures
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="flex justify-end gap-3 px-6 py-4 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700/50">
          <button
            onClick={onClose}
            className="py-2 px-4 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-600 font-medium"
          >
            Fermer
          </button>
          <button
            onClick={handleSave}
            className="py-2 px-4 bg-sky-600 text-white rounded-lg hover:bg-sky-700 font-medium flex items-center gap-2"
          >
            <Save size={18} />
            Enregistrer
          </button>
        </div>
      </div>
    </div>
  );
};

// ============================================
// COMPOSANT DASHBOARD PRINCIPAL
// ============================================
const Dashboard = ({ user, entreprise, onLogout }) => {
  const { profil } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState("dashboard");
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [toast, setToast] = useState(null);
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);
  const entrepriseId = entreprise?.id;
  const userMenuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setShowUserMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (searchParams.get("welcome") === "true") {
      setShowWelcomeModal(true);
      searchParams.delete("welcome");
      setSearchParams(searchParams, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  const showToast = (message, type = "success") => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3000);
  };

  const handleCloseWelcomeModal = () => {
    setShowWelcomeModal(false);
    showToast("Bienvenue sur CoryntiQ! 🎉", "success");
  };

  const NoEntrepriseMessage = () => (
    <div className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg p-8 text-center">
      <AlertTriangle size={48} className="text-amber-500 mx-auto mb-4" />
      <h3 className="text-lg font-semibold text-amber-800 dark:text-amber-200 mb-2">
        Chargement de l'entreprise...
      </h3>
      <p className="text-amber-600 dark:text-amber-300">
        Si ce message persiste, essayez de vous reconnecter.
      </p>
    </div>
  );

  const tabs = [
    { id: "dashboard", label: "Tableau de bord", icon: TrendingUp },
    { id: "inventaire", label: "Inventaire", icon: Database },
    { id: "analytics", label: "Analytique", icon: TrendingUp },
    { id: "calendar", label: "Calendrier", icon: Calendar },
    { id: "efvp", label: "EFVP", icon: Shield },
    { id: "consents", label: "Consentements", icon: Users },
    { id: "incidents", label: "Incidents", icon: AlertCircle },
    { id: "documents", label: "Documents", icon: FileText },
    { id: "audit", label: "Audit", icon: Clock },
    { id: "reports", label: "Rapports", icon: FileText },
    { id: "users", label: "Utilisateurs", icon: Users },
  ];

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 transition-colors">
      {showWelcomeModal && (
        <WelcomeModal user={user} onClose={handleCloseWelcomeModal} />
      )}
      {showProfileModal && (
        <ProfileModal
          isOpen={showProfileModal}
          onClose={() => setShowProfileModal(false)}
          user={user}
          profil={profil}
          entreprise={entreprise}
          showToast={showToast}
        />
      )}
      {showSettingsModal && (
        <SettingsModal
          isOpen={showSettingsModal}
          onClose={() => setShowSettingsModal(false)}
          entreprise={entreprise}
          showToast={showToast}
        />
      )}

      <header className="bg-gradient-to-r from-slate-800 via-slate-700 to-slate-800 dark:from-gray-800 dark:to-gray-900 text-white shadow-lg">
        <div className="w-full px-4 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="relative w-10 h-10 flex-shrink-0">
                <div className="absolute inset-0 rounded-full bg-gradient-to-br from-slate-400 to-slate-500"></div>
                <div
                  className="absolute rounded-full bg-gradient-to-br from-sky-300 to-sky-400"
                  style={{
                    top: "10%",
                    left: "10%",
                    width: "80%",
                    height: "80%",
                  }}
                ></div>
                <div
                  className="absolute rounded-full bg-gradient-to-br from-slate-700 to-slate-800"
                  style={{
                    top: "25%",
                    left: "25%",
                    width: "55%",
                    height: "55%",
                  }}
                ></div>
              </div>
              <div className="hidden sm:block">
                <h1 className="text-xl lg:text-2xl font-bold tracking-wide">
                  CORYNTI<span className="text-sky-300">Q</span>
                </h1>
                <p className="text-xs lg:text-sm text-slate-300 dark:text-gray-400">
                  Conformité Loi 25
                </p>
              </div>
            </div>

            <div className="flex items-center space-x-2 lg:space-x-4">
              {entreprise && (
                <div className="hidden md:block bg-slate-700 dark:bg-gray-700 border border-slate-600 dark:border-gray-600 text-white px-3 py-2 rounded-lg text-sm">
                  {entreprise.nom}
                </div>
              )}

              <ThemeToggle />

              <div className="relative">
                <button
                  onClick={() => {
                    setShowNotifications(!showNotifications);
                    setShowUserMenu(false);
                  }}
                  className="bg-slate-600 dark:bg-gray-700 hover:bg-slate-500 dark:hover:bg-gray-600 p-2 rounded-lg relative"
                >
                  <Bell size={20} />
                  <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
                </button>
                <NotificationsDropdown
                  isOpen={showNotifications}
                  onClose={() => setShowNotifications(false)}
                  entreprise={entreprise}
                />
              </div>

              <div className="relative" ref={userMenuRef}>
                <button
                  onClick={() => {
                    setShowUserMenu(!showUserMenu);
                    setShowNotifications(false);
                  }}
                  className="bg-slate-600 dark:bg-gray-700 hover:bg-slate-500 dark:hover:bg-gray-600 p-2 rounded-lg flex items-center space-x-2"
                >
                  <User size={20} />
                  <ChevronDown size={16} className="hidden sm:block" />
                </button>

                {showUserMenu && (
                  <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-lg shadow-lg py-2 z-50 border border-gray-200 dark:border-gray-700">
                    <div className="px-4 py-2 border-b border-gray-200 dark:border-gray-700">
                      <p className="text-sm font-medium text-gray-900 dark:text-gray-100">
                        {profil?.prenom ||
                          user?.user_metadata?.prenom ||
                          "Utilisateur"}
                      </p>
                      <p className="text-xs text-gray-500 dark:text-gray-400 truncate">
                        {user?.email}
                      </p>
                    </div>
                    <button
                      onClick={() => {
                        setShowProfileModal(true);
                        setShowUserMenu(false);
                      }}
                      className="w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center"
                    >
                      <User size={16} className="mr-2" />
                      Mon profil
                    </button>
                    <button
                      onClick={() => {
                        setShowSettingsModal(true);
                        setShowUserMenu(false);
                      }}
                      className="w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center"
                    >
                      <Settings size={16} className="mr-2" />
                      Paramètres
                    </button>
                    <button
                      onClick={onLogout}
                      className="w-full text-left px-4 py-2 text-sm text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900 flex items-center"
                    >
                      <LogOut size={16} className="mr-2" />
                      Déconnexion
                    </button>
                  </div>
                )}
              </div>

              <button
                onClick={() => setShowMobileMenu(!showMobileMenu)}
                className="lg:hidden bg-slate-600 dark:bg-gray-700 hover:bg-slate-500 p-2 rounded-lg"
              >
                {showMobileMenu ? <X size={20} /> : <Menu size={20} />}
              </button>
            </div>
          </div>
        </div>
      </header>

      <div className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700 hidden lg:block">
        <div className="w-full px-4 lg:px-8">
          <nav className="flex flex-wrap justify-center gap-1">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center space-x-2 px-4 py-3 font-medium transition-colors whitespace-nowrap ${
                    activeTab === tab.id
                      ? "text-sky-600 dark:text-sky-400 border-b-2 border-sky-600 dark:border-sky-400 bg-sky-50 dark:bg-sky-900/20"
                      : "text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white hover:bg-gray-50 dark:hover:bg-gray-700"
                  }`}
                >
                  <Icon size={18} />
                  <span className="text-sm">{tab.label}</span>
                </button>
              );
            })}
          </nav>
        </div>
      </div>

      {showMobileMenu && (
        <div className="lg:hidden bg-white dark:bg-gray-800 shadow-lg border-b border-gray-200 dark:border-gray-700">
          <nav className="grid grid-cols-2 gap-1 p-2">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => {
                    setActiveTab(tab.id);
                    setShowMobileMenu(false);
                  }}
                  className={`flex items-center space-x-2 px-3 py-3 rounded-lg font-medium transition-colors ${
                    activeTab === tab.id
                      ? "text-sky-600 dark:text-sky-400 bg-sky-50 dark:bg-sky-900/20"
                      : "text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700"
                  }`}
                >
                  <Icon size={18} />
                  <span className="text-sm">{tab.label}</span>
                </button>
              );
            })}
          </nav>
        </div>
      )}

      <div className="lg:hidden bg-sky-50 dark:bg-sky-900/20 px-4 py-2 border-b border-sky-100 dark:border-sky-800">
        <p className="text-sm text-sky-700 dark:text-sky-300 font-medium text-center">
          📍 {tabs.find((t) => t.id === activeTab)?.label}
        </p>
      </div>

      <main className="w-full px-4 lg:px-8 py-6">
        <div className="max-w-[1600px] mx-auto">
          {activeTab === "dashboard" &&
            (entrepriseId ? (
              <DashboardStats entrepriseId={entrepriseId} />
            ) : (
              <NoEntrepriseMessage />
            ))}
          {activeTab === "inventaire" &&
            (entrepriseId ? (
              <InventaireManager entrepriseId={entrepriseId} />
            ) : (
              <NoEntrepriseMessage />
            ))}
          {activeTab === "analytics" && (
            <EnhancedDashboard
              entrepriseId={entrepriseId}
              showToast={showToast}
            />
          )}
          {activeTab === "calendar" &&
            (entrepriseId ? (
              <CalendarViewSupabase entrepriseId={entrepriseId} />
            ) : (
              <NoEntrepriseMessage />
            ))}
          {activeTab === "efvp" &&
            (entrepriseId ? (
              <EFVPManager entrepriseId={entrepriseId} />
            ) : (
              <NoEntrepriseMessage />
            ))}
          {activeTab === "consents" &&
            (entrepriseId ? (
              <ConsentementsManager entrepriseId={entrepriseId} />
            ) : (
              <NoEntrepriseMessage />
            ))}
          {activeTab === "incidents" &&
            (entrepriseId ? (
              <IncidentsManager entrepriseId={entrepriseId} />
            ) : (
              <NoEntrepriseMessage />
            ))}
          {activeTab === "documents" &&
            (entrepriseId ? (
              <DocumentsManagerSupabase entrepriseId={entrepriseId} />
            ) : (
              <NoEntrepriseMessage />
            ))}
          {activeTab === "audit" && (
            <AuditTimeline entrepriseId={entrepriseId} showToast={showToast} />
          )}
          {activeTab === "reports" && (
            <ReportsGenerator
              showToast={showToast}
              entrepriseId={entrepriseId}
              entrepriseNom={entreprise?.nom}
            />
          )}
          {activeTab === "users" && (
            <UsersManagement
              showToast={showToast}
              entrepriseId={entrepriseId}
            />
          )}
        </div>
      </main>

      <footer className="bg-slate-800 dark:bg-gray-800 text-white mt-12">
        <div className="w-full px-4 lg:px-8 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-slate-300 dark:text-gray-400 text-center sm:text-left">
              © 2026 CoryntiQ - CIGP inc. - Tous droits réservés
            </p>
            <div className="flex items-center space-x-2 text-sm text-slate-300 dark:text-gray-400">
              <Lock size={16} />
              <span>Données sécurisées</span>
            </div>
          </div>
        </div>
      </footer>

      {toast && <Toast message={toast.message} type={toast.type} />}
    </div>
  );
};

export default Dashboard;
